import Badge from '@components/Badge';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import { pressActionEffect } from '@styles/mixin';

interface Props {
    label: string;
    /** 미적용 상태의 우측 안내 문구 (예: 3개 보유) */
    rightText?: string;
    /** 적용된 금액 문구. 있으면 빨간 뱃지로 표시한다 */
    appliedText?: string;
    disabled?: boolean;
    onClick?: () => void;
    ariaLabel?: string;
}

/** 쿠폰·선물·선불카드처럼 누르면 선택 화면으로 이동하는 행 */
function SelectRow({
    label, rightText, appliedText, disabled, onClick, ariaLabel,
}: Props) {
    return (
        <Container type='button'
            aria-label={ariaLabel}
            aria-disabled={disabled}
            onClick={() => {
                if (!disabled) {
                    onClick?.();
                }
            }} >
            <Label fontWeight='medium' color={colors.textPrimary}>
                {label}
            </Label>
            {appliedText ? (
                <Badge color='red'>{appliedText}</Badge>
            ) : (
                <Text color={disabled ? colors.textUnselected : colors.textSecondary}>{rightText}</Text>
            )}
            <ArrowLineRight size={16}
                color={disabled ? 'var(--color-icon-disabled)' : 'var(--color-icon-default)'}/>
        </Container>
    );
}

const Container = styled.button`
    align-items: center;
    background-color: var(--color-background-pure);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-m);
    column-gap: var(--spacing-4);
    display: flex;
    height: 52px;
    padding: var(--spacing-2) var(--spacing-4);
    text-align: left;
    width: 100%;
    ${pressActionEffect}

    &[aria-disabled="true"] {
        cursor: default;
        &:active {
            transform: none;
        }
    }
    

    > svg {
        flex-shrink: 0;
    }
`;

const Label = styled(Text)`
    flex: 1;
    min-width: 0;
`;

export default SelectRow;
